import { HttpMethod, RestfulEndpoint as RestfulEndpointBase, RestfulFetchOptions, RestfulIOOptions } from '@type-r/endpoints';
import { define, Events } from '@type-r/models';
import { getAuthToken, getGeneralPlatformCode } from './embedded-auth';

export function restfulIO( path : string, fetchOptions? : Partial<RestfulFetchOptions> ){
    return new RestfulEndpoint(
        path,
        fetchOptions,
        getAuthToken,
        getGeneralPlatformCode,
    );
}

export class RestfulEndpoint extends RestfulEndpointBase {
    tokenProvider: Function;
    platformCodeProvider: Function;

    constructor(path : string, fetchOptions? : Partial<RestfulFetchOptions>, tokenProvider: Function = getAuthToken, platforCodeProvider: Function = getGeneralPlatformCode ){
        super(path, fetchOptions);
        this.tokenProvider = tokenProvider;
        this.platformCodeProvider = platforCodeProvider;
    }
    // Append CORS service path...
    /*protected getRootUrl( recordOrCollection ) {
        const url = super.getRootUrl( recordOrCollection );
        return url //url.startsWith( 'http' ) ? url : this.removeTrailingSlash( RestfulEndpoint.ngContext.baseUrl ) + url;
    }*/

    // Add Authorization and other custom HTTP headers.
    protected buildRequestOptions( method : string, options? : RequestInit, body? ) : RequestInit {
        const requestOptions = super.buildRequestOptions( method, options, body );
        const token = this.tokenProvider();
        const platformCode = this.platformCodeProvider();
        if (!token) {
            return null;
        }
        requestOptions.headers[ 'Authorization' ] = `Bearer ${ token || '' }`;
        requestOptions.headers['X-Platform-Code'] = platformCode;

        return requestOptions;
    }

    protected async request( method: HttpMethod, url: string, {options}: RestfulIOOptions, body? ) {

        const requestOptions = this.buildRequestOptions( method, options, body );

        if( !requestOptions ) return null;

        const response = await fetch( url, requestOptions );

        if (response.ok) {
            try {
                return await response.json();
            } catch (e) {
                return {};
            }
        }
        else{
            if (response.status === 401 ) {
                localStorage.setItem('loggedIn', 'false');
                Events.trigger( 'navigate', '/login-cognito' );
            }

            const contentType = response.headers.get("content-type");
            let errorMessage;
      
            if (contentType && contentType.includes("application/json")) {
              const errorData = await response.json();
              errorMessage = errorData.message || "An error occurred";
      
              // Convert error message object to string if necessary
              if (typeof errorMessage === 'object') {
                errorMessage = JSON.stringify(errorMessage);
              }
            } else {
              errorMessage = await response.text();
            }

            throw new Error( response.statusText + ': ' + errorMessage );
        }
    }

    static ngContext : NgContext
}

export interface NgContext {
    baseUrl : string
}

/**
 * Implement custom model.fetch() according to the given rules.
 * All other I/O methods are not supported, this is read-only model.
 *
 * @param method HTTP Method to use
 * @param url template function to generate the URL
 * @param options options coming from `model.fetch( options )`
 */
export function nestedModelIO( path : string, fetchOptions? : Partial<RestfulFetchOptions> ){
    return new NestedModelIO( path, fetchOptions );
}

function notSupported( method ){
    throw new ReferenceError( `Method ${method} is not supported. modelFetchIO supports only model.fetch().` );
}

@define class NestedModelIO extends RestfulEndpoint {
    protected getUrl( record ) {
        return this.getRootUrl( record );
    }

    async list(){ notSupported( 'collection.fetch()') }
    async destroy(){ notSupported( 'model.destroy()') }
    async create(){ notSupported( 'model.save()') }
}

export async function fetchJson( method: HttpMethod, url: string, body?: object, formData?: FormData  ) {
    const token = getAuthToken();
    const platformCode = getGeneralPlatformCode();
    const requestBody = formData ? formData : JSON.stringify( body )

    const headers = new Headers({
        "Authorization": "Bearer " + token,
        "X-Platform-Code": platformCode
    });
    if (!formData) {
        headers.append("Content-Type", "application/json");
    }
    if (token) {
        const response = await fetch( url, {
            method,
            headers,
            body : requestBody
        });

        if (response.status === 401) {
            localStorage.setItem('loggedIn', 'false');
            Events.trigger('navigate', '/login-cognito');
        }
        if (response.status >= 400) throw new Error(response.status + ' ' + response.statusText);

        return await response.json();
    } else {
        return null;
    }

}

export async function fetchResponse( method: HttpMethod, url: string, body?: object ) {
    const token = getAuthToken();
    const platformCode = getGeneralPlatformCode();

    if (token) {
        const response = await fetch( url, {
            method,
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type" : "application/json",
                "X-Platform-Code": platformCode
            }),
            body : JSON.stringify( body )
        });

        if (response.status === 401) {
            localStorage.setItem('loggedIn', 'false');
            Events.trigger('navigate', '/login-cognito');
        }
        if (response.status >= 400) throw new Error(response.status + ' ' + response.statusText);

        return await response;
    } else {
        return null;
    }
}
